import React, { useEffect, useLayoutEffect, useState } from 'react';
import * as Styled from './AnimatedWrapper.styled';
/**
 * `AnimatedRender` is a wrapper component that controls the visibility and animation states of its children.
 * It supports smooth transitions for components mounting and unmounting using CSS animations.
 *
 * @example
 * ```jsx
 * <AnimatedRender visible={true} timeout={300} enterClass="fade-in" exitClass="fade-out">
 *   <div>Animated content here</div>
 * </AnimatedRender>
 * ```
 */
var AnimatedWrapper = function (_a) {
    var children = _a.children, _b = _a.visible, visible = _b === void 0 ? true : _b, _c = _a.enterClass, enterClass = _c === void 0 ? 'shrink-fade-in' : _c, _d = _a.exitClass, exitClass = _d === void 0 ? 'shrink-fade-out' : _d, onDelete = _a.onDelete, _e = _a.timeout, timeout = _e === void 0 ? 200 : _e;
    var _f = useState(visible), show = _f[0], setShow = _f[1];
    var animationClass = visible ? enterClass : exitClass;
    useLayoutEffect(function () {
        if (visible) {
            setShow(true);
        }
    }, [visible]);
    useEffect(function () {
        if (!visible && onDelete) {
            var timer_1 = setTimeout(onDelete, timeout);
            return function () { return clearTimeout(timer_1); };
        }
    }, [visible, onDelete, timeout]);
    var handleAnimationEnd = function () {
        if (!visible) {
            setShow(false);
        }
    };
    return show ? (React.createElement(Styled.AnimatedWrapper, { className: animationClass, onAnimationEnd: handleAnimationEnd, timeout: timeout }, children)) : null;
};
export default AnimatedWrapper;
